module.exports = __webpack_public_path__ + "img/mardelplata_summer.0a3d05d1.svg";